export default {
  START: "START",
  ORDER: "ORDER",
  UPDATE: "UPDATE",
  PAY: "PAY",
  COMPLETE: "COMPLETE"
}
